import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { SocialProofSection } from './components/SocialProofSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-[#0B0D17] text-white font-sans selection:bg-[#39FF14] selection:text-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="pt-10" data-id="element-2">
        {' '}
        {/* Padding to account for sticky urgency bar */}
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <SocialProofSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <ClosingSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}